import React from "react";
import { connect, useSelector } from "react-redux";
import { withRouter} from "react-router-dom";
import { withStyles } from "material-ui/styles";
import Icon from "material-ui/Icon";
import TextField from "material-ui/TextField";
import Button from "material-ui/Button";
import Grid from "material-ui/Grid";
import styles from "./styles";
import classnames from "classnames";
import Title from "../../ui/title";
import Content from "../../ui/content";
import Context from "../context/";
import { toast } from "react-toastify";

import Table from "../../table";
import TestsRowLink from "../../table/cells/testsRowLink";

import Back from "../../ui/back";

import Toolbar from "../toolbar/";

import JobHeader from "../../common/jobs/jobHeader";
import NewTests from "../new";
import CopperEditTests from "../newsignaltek/edit/copperedit";
import EditFiberTests from "../editfiber";
import RecertTests from "../recert";
import MoveTests from "../move";
import ReportGen from "../reportgen";
import CreateFiberTest from "../newfiber";
import ConfirmDialog from "../../common/dialog/confirm";
import ListAttachments from "../../common/jobandtestattachments/list";
import UploadAttachment from "../../common/jobandtestattachments/add";
import TestSelection from "../testselection";

import MuiPickersUtilsProvider from "material-ui-pickers/utils/MuiPickersUtilsProvider";
import TimePicker from "material-ui-pickers/TimePicker";
import DatePicker from "material-ui-pickers/DatePicker";
import DateTimePicker from "material-ui-pickers/DateTimePicker";
import moment from "moment";
import MomentUtils from "material-ui-pickers/utils/moment-utils";
import Badge from "material-ui/Badge";
import NewSignalTektestTests from "../newsignaltek";
import NewQualificationTest from "../newsignaltekqt";
import DeleteChoiceConfirm from "./delete/deletechoice";
import DeleteSubTests from "./delete/deletesubtests";

import SplitView from "../../splitview";
import Treeview from "../../treeview";
import QualificationEditTests from "../newsignaltekqt/edit/qualificationedit";

import {
  getISOTimeString,
  getISODateString,
  getISODateTimeString,
  isSignalTEKQTType,
  isSignalTEK10GType,
  isNaviTEKType,
  getSignalTEKPreset
} from "../../../common/utils";
import {
  metersToFeet,
  timeFormatter,
  dateTimeFormatter,
  getFormattedNumber
} from "../../../common/utils";
import {getPresetDefaultColumns} from "../../../common/tabletools";
import { resetJobTreeview } from "../../../redux/actions/jobActions";

moment.suppressDeprecationWarnings = true;

class SignalTek10GJob extends React.Component {
  constructor(props) {
    super(props);
    const { profile, nodeSelectedIds, modifiedJobId } = this.props;

    this.state = {
      modal: null,
      editTestsModal: null,
      editTestsModalError: null,
      recertTestModal: null,
      moveTestsModal: null,
      reportGenModal: null,
      deleteTestConfirm: false,
      contextMenu: false,
      tests: props.tests,
      treePath: props.location.state && props.location.state.path != undefined ? props.location.state.path :'',
      selectedTests: [],
      selected: {},
      selectAll: false,
      aggregateCols: [],
      expanded: null,
      test: null,
      lengthMeasurementUnit:
        profile && profile.units ? profile.units : "meters",
      jobAttachmentsModal: false,
      uploadModal: false,
      jobid: null,
      testid: null,
      filterable: false,
      filterdate: "",
      selectedDate: null,
      selectedTime: null,
      createdatDateTime: null,
      testSelected: {},
      fiberTestCreate: false,
      copperTestCreate: false,
      fiberTestEdit: false,
      isPreferenceUpdated: false,
      jobType: "",
      open: true,
      hasFiber: false,
      hasCopper: false,
      hasResult: false,
      onlyCopper: false,
      allCoperHasResult: false,
      onlyFiber: false,
      allFiberHasResult: false,
      partialResult: false,
      deleteTestChoice: false,
      deleteSubTestChoice: false,
      subTests: {
        ping4: false,
        ping6: false,
        traceroute4: false,
        traceroute6: false,
        netscan: false,
        wiremap: false,
        poeload: false,
        maxthroughput: false,
        uptime: false,
        customdata: false,
        cabledata: false,
        webdata: false,
        voipdata: false,
        videodata: false,
        cctvdata: false
      },
      isDeleteSubTest: false,
      withAndWithoutResult: false,
      includeChildren: false,
      nodeId: '',
      testCountForTreeview: null,
      jobDeleted: false,
      treeviewJob: null
    };
    this.toggle = this.toggle.bind(this);
    this.applyPreset = this.applyPreset.bind(this);
    this.toggleColumns = this.toggleColumns.bind(this);
    this.onSortedChange = this.onSortedChange.bind(this);
    this.onMoveTests = this.onMoveTests.bind(this);
    this.onMoveTestsClose = this.onMoveTestsClose.bind(this);
    this.showDeleteTestConfirm = this.showDeleteTestConfirm.bind(this);
    this.hideDeleteTestConfirm = this.hideDeleteTestConfirm.bind(this);
    this.onDeleteTest = this.onDeleteTest.bind(this);
    this.saveSignaltekNewTests = this.saveSignaltekNewTests.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { savePreferences, pager } = this.props;
    const { columns, isPreferenceUpdated } = this.state;
    if (columns && columns.length && !isPreferenceUpdated) {
      savePreferences(pager, columns, true);
      this.setState({ isPreferenceUpdated: true });
    }
    if (prevProps && this.props && prevProps.test !== this.props.test) {
      this.setState({
        test: this.props.test
      });
    }
  }

  activateSuspiciousFilter = e => {
    const { job, activateSuspiciousFilter, pager } = this.props;
    activateSuspiciousFilter(job.id, pager);
  };

  showAttachments = (e, jobid, testid) => {
    e.preventDefault();
    this.setState({
      jobid,
      testid,
      jobAttachmentsModal: true
    });
  };

  hideAttachments = e => {
    this.setState({
      jobid: null,
      testid: null,
      jobAttachmentsModal: false
    });
  };

  closeModal = reset => {
    const { getTests, pager } = this.props;
    const { jobid } = this.state;

    this.setState({
      jobid: null,
      testid: null,
      jobAttachmentsModal: false
    });
    getTests(pager, jobid);
  };

  showUplaodModal = () => {
    this.setState({
      uploadModal: true
    });
  };

  hideUplaodModal = () => {
    this.setState({
      uploadModal: false
    });
  };

  uploadFile = file => {
    const { jobid, testid } = this.state;
    const { uploadAttachment } = this.props;
    uploadAttachment(file, jobid, testid);
  };

  checkRecertify = () => {
    const { job } = this.props;
    const { selectedTests } = this.state;
    if (job && job.deviceid && selectedTests && selectedTests.length) {
      const hasLt4FiberTest = selectedTests.find(
        test => test.testtype === "39"
      );
      if (hasLt4FiberTest) {
        return false;
      } else {
        return true;
      }
    }
    return false;
  };

  checkShowEdit = () => {
    const { selectedTests, withAndWithoutResult } = this.state;
    const { job } = this.props;
    let hasFiber = false;
    let hasCopper = false;
    let hasResult = false;
    let withResult = 0;
    let withoutResult = 0;
    let onlyCopper = false;
    let allCoperHasResult = false;
    let onlyFiber = false;
    let allFiberHasResult = false;
    let partialResult = false;
    let isDeleteSubTest = false;

    if (selectedTests && selectedTests.length) {
      if (selectedTests.length > 1) {
        if (job.deviceid) {
          selectedTests.forEach(x => {
            if (x.result_teststatus === null || x.result_teststatus === "") {
              withoutResult++;
            } else {
              withResult++;
              isDeleteSubTest = true;
            }
          });
        }
        if (withResult > 0 && withoutResult > 0) {
          partialResult = true;
        } else {
          partialResult = false;
        }
        selectedTests.forEach(test => {
          if (
            test.testinterface &&
            test.testinterface.toLowerCase() === "copper"
          ) {
            hasCopper = true;
          } else if (
            test.testinterface &&
            test.testinterface.toLowerCase() === "fiber"
          ) {
            hasFiber = true;
          }
        });

        if (hasCopper && !hasFiber) {
          onlyCopper = true;
          onlyFiber = false;
        } else if (!hasCopper && hasFiber) {
          onlyFiber = true;
          onlyCopper = false;
        } else if (hasCopper && hasFiber) {
          onlyCopper = false;
          onlyFiber = false;
        }
        // only copper
        if (onlyCopper) {
          if (withResult > 0 && withoutResult == 0) {
            allCoperHasResult = true;
          } else {
            allCoperHasResult = false;
          }
          if (
            onlyCopper !== this.state.onlyCopper ||
            this.state.allCoperHasResult !== allCoperHasResult
          ) {
            this.setState({ onlyCopper, allCoperHasResult, onlyFiber });
          }
        } else {
          if (onlyCopper !== this.state.onlyCopper) {
            this.setState({ onlyCopper });
          }
        }
        // only fiber
        if (onlyFiber) {
          if (withResult > 0 && withoutResult == 0) {
            allFiberHasResult = true;
          } else {
            allFiberHasResult = false;
          }
          if (
            onlyFiber !== this.state.onlyFiber ||
            this.state.allFiberHasResult !== allFiberHasResult
          ) {
            this.setState({ onlyFiber, allFiberHasResult, onlyCopper });
          }
        } else {
          if (onlyFiber !== this.state.onlyFiber) {
            this.setState({ onlyFiber });
          }
        }
        if (partialResult !== this.state.partialResult) {
          this.setState({ partialResult });
        }
        if (isDeleteSubTest != this.state.isDeleteSubTest) {
          this.setState({ isDeleteSubTest: isDeleteSubTest });
        }
        // check for metadata group
        let level1value = selectedTests[0].level1value;
        let level2value = selectedTests[0].level2value;
        let level3value = selectedTests[0].level3value;
        let level4value = selectedTests[0].level4value;
        let level5value = selectedTests[0].level5value;
        let level6value = selectedTests[0].level6value;
        let multiMetadataCheck = selectedTests.filter(
          test =>
            test.level1value !== level1value ||
            test.level2value !== level2value ||
            test.level3value !== level3value ||
            test.level4value !== level4value ||
            test.level5value !== level5value ||
            test.level6value !== level6value
        );
        if (multiMetadataCheck.length && multiMetadataCheck.length > 0) {
          return false;
        }
      } else if (
        selectedTests &&
        selectedTests.length &&
        selectedTests.length == 1
      ) {
        selectedTests.forEach(test => {
          if (
            test.testinterface &&
            test.testinterface.toLowerCase() === "copper"
          ) {
            hasCopper = true;
          } else if (
            test.testinterface &&
            test.testinterface.toLowerCase() === "fiber"
          ) {
            hasFiber = true;
          }
        });
        selectedTests.forEach(x => {
          if (x.result_teststatus === null || x.result_teststatus === "") {
            withoutResult++;
          } else {
            withResult++;
          }
        });
        hasResult = withResult > 0 ? true : false;
        if (
          this.state.hasCopper !== hasCopper ||
          this.state.hasFiber !== hasFiber ||
          hasResult !== this.state.hasResult
        ) {
          this.setState({
            hasCopper,
            hasFiber,
            hasResult,
            partialResult: false
          });
        }
        if (isDeleteSubTest != this.state.isDeleteSubTest) {
          this.setState({ isDeleteSubTest: isDeleteSubTest });
        }
      }
      return true;
    }
    return false;
  };

  saveTest = (test, pager) => {
    this.setState({ selected: {}, selectedTests: [] });
    this.props.saveNewTests(test, pager);
  };

  resetTestCounter = () => {
    this.setState({ selected: {}, selectedTests: [] });
  };

  saveFibertest = (test, pager) => {
    this.setState({ selected: {}, selectedTests: [] });
    this.props.saveFiberNewTests(test, pager);
  };

  saveSignaltekNewTests(test, pager) {
    this.setState({ selected: {}, selectedTests: [] });

    let preferenceModel = {
      metadata: test.metadata,
      ping4: test.ping4 && test.ping4 == true ? true : false,
      ping6: test.ping6 && test.ping6 == true ? true : false,
      traceroute4: test.traceroute4 && test.traceroute4 == true ? true : false,
      traceroute6: test.traceroute6 && test.traceroute6 == true ? true : false,
      netscan: test.netscan && test.netscan == true ? true : false,
      maxthroughput:
        test.maxthroughput && test.maxthroughput == true ? true : false,
      uptime: test.uptime && test.uptime == true ? true : false,
      customdata: test.customdata && test.customdata == true ? true : false,
      cabledata: test.cabledata && test.cabledata == true ? true : false,
      webdata: test.webdata && test.webdata == true ? true : false,
      voipdata: test.voipdata && test.voipdata == true ? true : false,
      videodata: test.videodata && test.videodata == true ? true : false,
      cctvdata: test.cctvdata && test.cctvdata == true ? true : false,
      wiremap: test.wiremap && test.wiremap == true ? true : false,
      poeload: test.poeload && test.poeload == true ? true : false
    };
    this.props.postUserPreference(true, preferenceModel);
    if (test.interfaceid && test.interfaceid == 1) {
      test.poeload = false;
      test.wiremap = false;
    }

    this.props.saveSignaltekNewTests(test, pager);
  }

  testSelection = (fiber, copper) => {
    if (copper) {
      this.setState({
        copperTestCreate: true,
        fiberTestCreate: false,
        open: true,
        modal: false
      });
    } else if (fiber) {
      this.setState({
        fiberTestCreate: true,
        copperTestCreate: false,
        open: true,
        modal: false
      });
    }
  };

  handleClose = () => {
    this.setState({
      open: false,
      fiberTestCreate: false,
      copperTestCreate: false,
      selected: {},
      selectedTests: []
    });
  };

  onSubtestChange = e => {
    const { subTests } = this.state;
    subTests[e.target.name] = e.target.checked;
    this.setState({ subTests });
  };

  render() {
    const {
      classes,
      translate,
      job,
      jobs,
      standards,
      fiberStandards,
      custom,
      languages,
      saveNewTests,
      saveFiberNewTests,
      testsCreated,
      errors,
      pager,
      fetch,
      copperModalState,
      fiberModalState,
      savePreferences,
      applyPreset,
      columnPreset,
      preferences,
      preferencesSaved,
      customers,
      customer,
      getCustomer,
      attachments,
      getAttachments,
      deleteAttachment,
      attachmentDownload,
      filteredJobs,
      getJobs,
      refresh,
      selectedCustomerName,
      selectedCustomerId,
      clearAttachments,
      resetForm,
      fibertest,
      selectedLanguage,
      signaltekModalState,
      saveSelectedRow,
      previousRow,
      testNames,
      userPreference,
      uploadTestIDFile,
      testNameList,
      IDerrors,
      clearDuplicateError,
      clearImportDuplicateError,
      countryStates,
      nodeSelectedIds,
      modifiedJobId,
      fileUploadSettings,
    } = this.props;
    const {
      modal,
      editTestsModal,
      editTestsModalError,
      recertTestModal,
      moveTestsModal,
      reportGenModal,
      tests,
      test,
      selectAll,
      selectedTests,
      selected,
      aggregateCols,
      filterable,
      testSelected,
      lengthMeasurementUnit,
      jobType,
      open,
      hasFiber,
      hasCopper,
      hasResult,
      onlyCopper,
      allCoperHasResult,
      onlyFiber,
      allFiberHasResult,
      partialResult,
      isDeleteSubTest,
      jobDeleted,
      treeviewJob
    } = this.state;

    const isSignalTEKQTJob = job.deviceid && isSignalTEKQTType(job.deviceid);

    // filter the tests by the path from the treeview
    // if the path is | delimited it is a click from the treeview, otherwise a navigation from a job click
    if (tests){
      var path = this.state.treePath.split('|');
      var pathLength = path.length;

      var pathToCheckAgainst = path.slice(3, pathLength -1);

      const checkLevel = (pathItem, test) => {

        var id6 = test[`level6id`];
        var id5 = test[`level5id`];
        var id4 = test[`level4id`];
        var id3 = test[`level3id`];
        var id2 = test[`level2id`];

        if (nodeSelectedIds.includes(id6) || nodeSelectedIds.includes(id5) || nodeSelectedIds.includes(id4) || nodeSelectedIds.includes(id3) || nodeSelectedIds.includes(id2)) {
          return true;
        }

        return false;
      };

      var filteredTests = tests.data.filter(testItem => {
        return pathToCheckAgainst.every((item) => {
          if (nodeSelectedIds === null || nodeSelectedIds === '') {
            return true;
          }
          return checkLevel(item, testItem )
        })
      });
    }

    const isNaviTEKJob = job.deviceid && isNaviTEKType(job.deviceid);
    const createEnabled = job.deviceid && !isNaviTEKJob ? true : false;
    let $modal = null;
    if (modal) {
      $modal = (
        <TestSelection
          translate={translate}
          testSelection={(fiber, copper) => this.testSelection(fiber, copper)}
          cancel={(cancel, modelType) => this.add(cancel, modelType)}
          jobType={jobType}
        />
      );
    }

    let $fiberTestModal = null;
    let $stfiberTestModal = null;
    if (this.state.fiberTestCreate) {
      {
        jobType == "Lantek4"
          ? ($fiberTestModal = (
              <CreateFiberTest
                job={job}
                standards={standards}
                fiberStandards={fiberStandards}
                custom={custom}
                saveNewTests={this.saveFibertest}
                translate={translate}
                cancel={cancel => this.add(cancel, "fibertestModal")}
                testsCreated={testsCreated}
                error={errors}
                pager={pager}
                modalState={fiberModalState}
                selectedCustomerId={selectedCustomerId}
                lengthMeasurementUnit={lengthMeasurementUnit}
                userPreference={userPreference}
              />
            ))
          : (isSignalTEKQTJob ? ($stfiberTestModal = (
            <NewQualificationTest
              job={job}
              standards={standards}
              custom={custom}
              saveEditTest={null}
              saveNewTests={this.saveSignaltekNewTests}
              translate={translate}
              cancel={cancel => this.add(cancel, "coppertestModal")}
              testsCreated={testsCreated}
              error={errors}
              pager={pager}
              modalState={signaltekModalState}
              selectedCustomerId={selectedCustomerId}
              type="fiber"
              open={open}
              handleClose={this.handleClose}
              userPreference={userPreference}
              uploadTestIDFile={uploadTestIDFile}
              testNameList={testNameList}
              IDerrors={IDerrors}
              clearDuplicateError={clearDuplicateError}
              clearImportDuplicateError={clearImportDuplicateError}
              lengthMeasurementUnit={lengthMeasurementUnit}
            />
            )) :
            ($stfiberTestModal = (
              <NewSignalTektestTests
                job={job}
                standards={standards}
                custom={custom}
                saveNewTests={this.saveSignaltekNewTests}
                translate={translate}
                cancel={cancel => this.add(cancel, "coppertestModal")}
                testsCreated={testsCreated}
                error={errors}
                pager={pager}
                modalState={signaltekModalState}
                selectedCustomerId={selectedCustomerId}
                type="fiber"
                open={open}
                handleClose={this.handleClose}
                userPreference={userPreference}
                uploadTestIDFile={uploadTestIDFile}
                testNameList={testNameList}
                IDerrors={IDerrors}
                clearDuplicateError={clearDuplicateError}
                clearImportDuplicateError={clearImportDuplicateError}
                lengthMeasurementUnit={lengthMeasurementUnit}
              />
            )));
      }
    }
    let $editFiberTestModal = null;
    if (this.state.fiberTestEdit) {
      $editFiberTestModal = isSignalTEKQTJob ? (
        <QualificationEditTests
        job={job}
        custom={custom}
        multiple={selectedTests && selectedTests.length > 1 ? true : false}
        saveEditTest={this.onSaveEditTest.bind(this)}
        translate={translate}
        cancel={() => this.closeEdit()}
        testsCreated={testsCreated}
        pager={pager}
        test={test}
        error={editTestsModalError}
        errors={errors}
        resetForm={resetForm}
        selectedCustomerId={selectedCustomerId}
        selectedTests={selectedTests}
        isCopper={hasCopper}
        isFiber={hasFiber}
        hasResult={hasResult}
        onlyCopper={onlyCopper}
        allCoperHasResult={allCoperHasResult}
        onlyFiber={onlyFiber}
        allFiberHasResult={allFiberHasResult}
        type="fiber"
        partialResult={partialResult}
        testNames={testNames}
        lengthMeasurementUnit={lengthMeasurementUnit}
      />
      ) : (
        <CopperEditTests
          job={job}
          standards={standards}
          custom={custom}
          multiple={selectedTests && selectedTests.length > 1 ? true : false}
          saveEditTest={this.onSaveEditTest.bind(this)}
          translate={translate}
          cancel={() => this.closeEdit()}
          testsCreated={testsCreated}
          pager={pager}
          modalState={signaltekModalState}
          test={test}
          error={editTestsModalError}
          resetForm={resetForm}
          selectedCustomerId={selectedCustomerId}
          selectedTests={selectedTests}
          isCopper={hasCopper}
          isFiber={hasFiber}
          hasResult={hasResult}
          onlyCopper={onlyCopper}
          allCoperHasResult={allCoperHasResult}
          onlyFiber={onlyFiber}
          allFiberHasResult={allFiberHasResult}
          error={errors}
          type="fiber"
          partialResult={partialResult}
          testNames={testNames}
          lengthMeasurementUnit={lengthMeasurementUnit}
        />
      );
    }
    let $coppertestModal = null;
    let $stcoppertestModal = null;
    if (this.state.copperTestCreate) {
      {
        jobType == "Lantek4"
          ? ($coppertestModal = (
              <NewTests
                job={job}
                standards={standards}
                custom={custom}
                saveNewTests={this.saveTest}
                translate={translate}
                cancel={cancel => this.add(cancel, "coppertestModal")}
                testsCreated={testsCreated}
                error={errors}
                pager={pager}
                modalState={copperModalState}
                selectedCustomerId={selectedCustomerId}
                type="copper"
                userPreference={userPreference}
                clearDuplicateError={clearDuplicateError}
                clearImportDuplicateError={clearImportDuplicateError}
              />
            ))
          : (isSignalTEKQTJob ? ($stcoppertestModal = (
            <NewQualificationTest
              job={job}
              standards={standards}
              custom={custom}
              saveEditTest={null}
              saveNewTests={this.saveSignaltekNewTests}
              translate={translate}
              cancel={cancel => this.add(cancel, "coppertestModal")}
              testsCreated={testsCreated}
              error={errors}
              pager={pager}
              modalState={signaltekModalState}
              selectedCustomerId={selectedCustomerId}
              type="copper"
              open={open}
              handleClose={this.handleClose}
              userPreference={userPreference}
              uploadTestIDFile={uploadTestIDFile}
              testNameList={testNameList}
              IDerrors={IDerrors}
              clearDuplicateError={clearDuplicateError}
              clearImportDuplicateError={clearImportDuplicateError}
              lengthMeasurementUnit={lengthMeasurementUnit}
            />
            )) : ($stcoppertestModal = (
              <NewSignalTektestTests
                job={job}
                standards={standards}
                custom={custom}
                saveNewTests={this.saveSignaltekNewTests}
                translate={translate}
                cancel={cancel => this.add(cancel, "coppertestModal")}
                testsCreated={testsCreated}
                error={errors}
                pager={pager}
                modalState={signaltekModalState}
                selectedCustomerId={selectedCustomerId}
                type="copper"
                open={open}
                handleClose={this.handleClose}
                userPreference={userPreference}
                uploadTestIDFile={uploadTestIDFile}
                testNameList={testNameList}
                IDerrors={IDerrors}
                clearDuplicateError={clearDuplicateError}
                clearImportDuplicateError={clearImportDuplicateError}
                lengthMeasurementUnit={lengthMeasurementUnit}
              />
            )));
      }
    }
    let $editTestsModal = null;
    if (editTestsModal) {

      $editTestsModal = isSignalTEKQTJob ? (
        <QualificationEditTests
          job={job}
          custom={custom}
          multiple={selectedTests && selectedTests.length > 1 ? true : false}
          saveEditTest={this.onSaveEditTest.bind(this)}
          translate={translate}
          cancel={() => this.closeEdit()}
          testsCreated={testsCreated}
          pager={pager}
          test={test}
          error={editTestsModalError}
          errors={errors}
          resetForm={resetForm}
          selectedCustomerId={selectedCustomerId}
          selectedTests={selectedTests}
          isCopper={hasCopper}
          isFiber={hasFiber}
          hasResult={hasResult}
          onlyCopper={onlyCopper}
          allCoperHasResult={allCoperHasResult}
          onlyFiber={onlyFiber}
          allFiberHasResult={allFiberHasResult}
          type="copper"
          partialResult={partialResult}
          testNames={testNames}
          lengthMeasurementUnit={lengthMeasurementUnit}
        />
        ) : (
        <CopperEditTests
          job={job}
          standards={standards}
          custom={custom}
          multiple={selectedTests && selectedTests.length > 1 ? true : false}
          saveEditTest={this.onSaveEditTest.bind(this)}
          translate={translate}
          cancel={() => this.closeEdit()}
          testsCreated={testsCreated}
          pager={pager}
          modalState={signaltekModalState}
          test={test}
          error={editTestsModalError}
          resetForm={resetForm}
          selectedCustomerId={selectedCustomerId}
          selectedTests={selectedTests}
          isCopper={hasCopper}
          isFiber={hasFiber}
          hasResult={hasResult}
          onlyCopper={onlyCopper}
          allCoperHasResult={allCoperHasResult}
          onlyFiber={onlyFiber}
          allFiberHasResult={allFiberHasResult}
          type="copper"
          partialResult={partialResult}
          testNames={testNames}
          lengthMeasurementUnit={lengthMeasurementUnit}
        />
      );
    }

    let $recertTestModal = null;
    if (recertTestModal) {
      $recertTestModal = (
        <RecertTests
          job={job}
          standards={standards}
          saveRecertTest={this.onSaveRecertTest.bind(this)}
          translate={translate}
          cancel={() => this.closeRecert()}
          testsCreated={testsCreated}
          pager={pager}
        />
      );
    }

    let $moveTestsModal = null;
    if (moveTestsModal) {
      $moveTestsModal = (
        <MoveTests
          translate={translate}
          selectedTests={selectedTests}
          job={job}
          jobs={jobs}
          selectedtotal={selectedTests && selectedTests.length}
          selectAll={selectAll}
          onClose={this.onMoveTestsClose}
          onSubmit={this.onMoveTests}
          filteredJobs={filteredJobs}
          getJobs={getJobs}
        />
      );
    }

    let $reportGenModal = null;
    if (reportGenModal) {
      $reportGenModal = (
        <ReportGen
          job={this.state.treeviewJob ? this.state.treeviewJob : job}
          language={selectedLanguage}
          translate={translate}
          languages={languages}
          customers={customers}
          customer={customer}
          getCustomer={getCustomer}
          selectedTests={selectedTests}
          selectedtotal={(this.state.nodeId == null || this.state.nodeId.length <= 0)  ? selectedTests && selectedTests.length : this.state.testCountForTreeview}
          selectAll={selectAll}
          cancel={() => this.hideReportGen()}
          submit={data => this.generateReport(data)}
          countryStates={countryStates}
        />
      );
    }
    let $deleteTestConfirm = (
      <ConfirmDialog
        open={this.state.deleteTestConfirm}
        title={
          this.state.deleteSubTestChoice
            ? translate("delete_specific_subtests")
            : translate("tests_delete_confirm_title")
        }
        contentText={
          this.state.deleteSubTestChoice
            ? translate("subtests_delete_confirm_text")
            : translate("tests_delete_confirm_text", {
                number: selectedTests && selectedTests.length
              })
        }
        contentSecondaryText={translate("general_confirmation_help_2")}
        okText={translate("general_confirm")}
        cancelText={translate("general_cancel")}
        onOk={this.onDeleteTest}
        onCancel={this.hideDeleteTestConfirm}
        deleteSubTestChoice={this.state.deleteSubTestChoice}
      />
    );

    let showDeleteSubTestButton = true;
    if (isSignalTEKQTJob && selectedTests && selectedTests.length) {
      showDeleteSubTestButton = false;
      selectedTests.forEach(x => {
        if (!showDeleteSubTestButton && (x.result_teststatus !== null) && (x.result_teststatus.length > 0) && (x.result_fiber === null) && (x.result_wiremap === null)) {
          showDeleteSubTestButton = true;
        }
      });
    }

    let $deleteTestChoice = (
      <DeleteChoiceConfirm
        open={this.state.deleteTestChoice}
        title={translate("tests_delete_confirm_title")}
        contentText={translate("tests_delete_choice_text", {
          number: selectedTests && selectedTests.length
        })}
        contentSecondaryText={""}
        okDeleteTestText={translate("tests_delete_confirm_title")}
        okDeleteSubTestText={showDeleteSubTestButton ? translate("tests_delete_subtest_confirm") : null}
        onDeleteTest={this.showDeleteTestConfirm}
        onDeleteSubTest={this.showSubTestDeleteChoice}
        onCancel={this.hideDeleteTestChoice}
      />
    );

    let $deleteSubTestChoice = (
      <DeleteSubTests
        open={this.state.deleteSubTestChoice}
        title={translate("delete_specific_subtests")}
        contentText={translate("select_subtests_delete")}
        contentSecondaryText={""}
        okDeleteTestText={translate("general_confirm")}
        onDeleteTest={this.showDeleteTestConfirm}
        onCancel={this.hideSubTestDeleteChoice}
        translate={translate}
        subTests={this.state.subTests}
        onSubtestChange={this.onSubtestChange}
        isSignalTEKQTJob={isSignalTEKQTJob}
      />
    );

    let $context = (
      <Context
        job={job}
        toggleColumns={this.toggleColumns}
        applyPreset={this.applyPreset}
        columnPreset={columnPreset}
        data={tests ? tests.data : []}
        columns={
          preferences && preferences.columns
            ? preferences.columns
            : this.state.columns
        }
        translate={translate}
        isSignaltek10g={true}
      />
    );

    let $jobAttachmentsModal = this.state.jobAttachmentsModal ? (
      <ListAttachments
        translate={translate}
        close={this.closeModal}
        jobid={this.state.jobid}
        testid={this.state.testid}
        attachments={attachments}
        getAttachments={getAttachments}
        hideUplaodModal={this.hideUplaodModal}
        showUplaodModal={this.showUplaodModal}
        deleteAttachment={deleteAttachment}
        attachmentDownload={attachmentDownload}
        clearAttachments={clearAttachments}
      />
    ) : null;

    let $fileUploadModal = this.state.uploadModal ? (
      <UploadAttachment
        translate={translate}
        jobid={this.state.jobid}
        testid={this.state.testid}
        hideUplaodModal={this.hideUplaodModal}
        uploadFile={this.uploadFile}
        fileUploadSettings={fileUploadSettings}
      />
    ) : null;

    if (filteredTests){
      tests.data = filteredTests;
    }

    let expanded = {};
    let data = [];
    if (aggregateCols.length && tests && tests.data && tests.data.length) {
      let hash = {},
        grouped = [],
        groups = [];
      tests.data.forEach(function(o) {
        let key = [
          "level2value",
          "level3value",
          "level4value",
          "level5value",
          "level6value",
          "level2key",
          "level3key",
          "level4key",
          "level5key",
          "level6key"
        ]
          .map(k => {
            return o[k];
          })
          .join("|");

        if (!hash[key]) {
          hash[key] = { key };
          let obj = {};
          let str = "";
          let levels = [6, 5, 4, 3, 2];
          let nbsp = String.fromCharCode(160);
          levels.map(idx => {
            // if (o[`level${idx}value`]) {
            // obj[o[`level${idx}value`]] = o[`level${idx}key`]
            obj[`level${idx}value`] = o[`level${idx}value`];
            obj[`level${idx}key`] = o[`level${idx}key`];
            if (o[`level${idx}key`]) {
              str +=
                o[`level${idx}key`] +
                ":" +
                nbsp +
                o[`level${idx}value`] +
                nbsp +
                nbsp +
                nbsp;
            }
            return idx;
          });
          groups.push({
            group: true,
            filter: obj,
            str
          });
          grouped.push(hash[key]);
        }
      });
      groups.map(group => {
        let filtered = tests.data.filter(obj => {
          for (var key in group.filter) {
            if (obj[key] === undefined || obj[key] !== group.filter[key]) {
              return false;
            }
          }
          return true;
        });
        data.push(group, ...filtered);
        return group;
      });

      grouped.map((d, k) => {
        expanded[k] = {};
        return d;
      });
    }

    const tableSortProps =
      pager && pager.sort
        ? {
            sorted: pager && pager.sort ? pager.sort : []
          }
        : null;

    const tableFilterProps =
      pager && pager.filter
        ? {
            filtered: pager && pager.filter ? pager.filter : undefined
          }
        : null;

    const tablePageProps =
      pager && pager.pageIndex !== undefined
        ? {
            page:
              pager && pager.pageIndex !== undefined
                ? pager.pageIndex
                : undefined
          }
        : null;

    let all =
      Object.keys(this.state.selected).length &&
      Object.keys(this.state.selected)
        .map(c => this.state.selected[c])
        .every(x => x);

    let isShowEdit = this.checkShowEdit();
    let isRecertify = this.checkRecertify();
    return (
      <div>
        <Title
          title={job.name}
          custTitle={
            selectedCustomerName && (
              <Back
                title={translate("general_customers")}
                link={"/customers"}
              />
            )
          }
          custName={
            selectedCustomerName && (
              <Back
                title={selectedCustomerName}
                link={`/customers/${selectedCustomerId}`}
              />
            )
          }
          back={
            <Back
              link={
                selectedCustomerId ? `/jobs/${selectedCustomerId}` : "/jobs"
              }
              title={translate("general_jobs")}
            />
          }
          toolbar={
            <Toolbar
              translate={translate}
              toggle={() => this.toggle()}
              createEnabled={createEnabled}
              add={() =>
                this.add(
                  null,
                  jobType == "Lantek4"
                    ? "testSelection"
                    : "testSelection_signaltek"
                )
              }
              showEdit={isShowEdit}
              job={job}
              showMove={
                (selectedTests && selectedTests.length) || all ? true : false
              }
              showDelete={
                (selectedTests && selectedTests.length) || all ? true : false
              }
              showRecert={false}
              showReportGen={
                (selectedTests && selectedTests.length) || all ? true : false
              }
              move={() => this.move()}
              edit={() => this.edit()}
              recert={() => this.recert()}
              del={
                !hasResult && !isDeleteSubTest
                  ? this.showDeleteTestConfirm
                  : this.showDeleteTestChoice
              }
              reportGen={() => this.showReportGen()}
              toggleFilters={this.toggleFilters}
              refresh={refresh}
            />
          }
        />
        <SplitView show={true} left={<Treeview jobDeleted={jobDeleted} jobs={jobs} job={job} resetTestCount={this.resetTestCounter} refreshTest={refresh} translate={translate} showReportModal={this.showReportFromTreeview} showAddJob={false}></Treeview>}>
        <Content
          ctx={$context}
          open={this.state.contextMenu}
          toggle={() => this.toggle()}
          translate={translate}
        >
          <JobHeader
            job={job}
            translate={translate}
            totalSelected={selectedTests.length}
            isSelectionShow={true}
          />
          {/* selected={selected} */}
          {tests ? (
            <Table
              translate={translate}
              filterable={filterable}
              minRows={0}
              pages={tests ? tests.pagecount : 0}
              manual={pager.manual}
              defaultPageSize={pager.pagesize}
              data={tests ? data : []}
              columns={this.state.columns}
              fetch={fetch}
              onSortedChange={this.onSortedChange}
              allowSelect
              allowDnd={true}
              selectedRows={this.selectedRows}
              selected={selected}
              testSelected={testSelected}
              selectAll={selectAll}
              selectedTests={selectedTests}
              saveSelectedRow={saveSelectedRow}
              previousRow={previousRow}
              isShiftSelectPage={true}
              expanded={Array.from(
                Array(data.length),
                (val, index) => index + 1
              )}
              expanderDefaults={{ show: false }}
              style={{
                border: "none",
                marginTop: "50px"
              }}
              noDataText={createEnabled ? "no_test_data" : "no_lt3_test_data"}
              minRows={tests.data && tests.data.length ? 0 : undefined}
              getTrProps={(state, rowInfo, column) => {
                if (rowInfo && rowInfo.original && rowInfo.original.group) {
                  return {
                    style: {
                      height: "0px",
                      display: "none"
                    }
                  };
                }
                return {};
              }}
              SubComponent={row => {
                if (!row.original.group) {
                  return;
                }
                let content = row.original.str;
                // Object.keys(row.original).map((k, idx) => {
                //   if (k && k !== 'group') {
                //     content += `${k}: ${row.original[k]}     `
                //   }
                // })
                // if (content === '') content = ''
                let groupSize = 12;
                let filterSize = 0;
                if (!row.index) {
                  groupSize = 10;
                  filterSize = 2;
                }
                return (
                  <Grid container spacing={0}>
                    <Grid
                      item
                      xs={groupSize}
                      style={{
                        height: "40px",
                        backgroundColor: "#1F2532",
                        color: "white",
                        padding: "5px 5px 5px 20px",
                        lineHeight: "34px"
                      }}
                    >
                      {content}
                    </Grid>
                    {!row.index && (
                      <Grid
                        item
                        xs={filterSize}
                        style={{
                          height: "40px",
                          backgroundColor: "#1F2532",
                          color: "white",
                          padding: "0px"
                        }}
                      >
                        {/* <Button
                          variant="outlined"
                          className={classnames(
                            classes.button,
                            classes.suspiciousfilter,
                            job.suspicious
                              ? classes.suspiciousfilteractivated
                              : classes.suspiciousfilternotrun
                          )}
                          onClick={this.activateSuspiciousFilter}
                        >
                          {translate("suspicious_filter")}
                          <Icon>{job.suspicious ? "sync" : "play_arrow"}</Icon>
                        </Button> */}
                      </Grid>
                    )}
                  </Grid>
                );
              }}
              savePreferences={savePreferences}
              applyPreset={applyPreset}
              preferences={preferences}
              preferencesSaved={preferencesSaved}
              pager={pager}
              {...tableFilterProps}
              {...tableSortProps}
              {...tablePageProps}
            />
          ) : null}
          {$modal}
          {$editTestsModal}
          {$moveTestsModal}
          {$deleteTestConfirm}
          {$recertTestModal}
          {$reportGenModal}
          {$jobAttachmentsModal}
          {$fileUploadModal}
          {$coppertestModal}
          {$fiberTestModal}
          {$stcoppertestModal}
          {$stfiberTestModal}
          {$editFiberTestModal}
          {$deleteTestChoice}
          {$deleteSubTestChoice}
        </Content>
        </SplitView>
      </div>
    );
  }

  add = async (isCancel, modelType) => {
    if (!this.props.standards) {
      await this.props.getStandards();
    }
    if (!this.props.fiberStandards) {
      await this.props.getFiberStandards();
    }
    if (isCancel === "cancel") {
      this.props.clearDuplicateError();
      this.props.clearImportDuplicateError();
    }
    if (!this.props.custom) {
      this.props.getCustom();
    }
    if (isCancel === "cancel" && modelType === "testSelection") {
      this.setState({
        modal: false
      });
    } else if (modelType === "testSelection") {
      this.setState({
        modal: true
      });
    }
    if (isCancel === "cancel" && modelType === "testSelection_signaltek") {
      this.setState({
        modal: false
      });
    } else if (modelType === "testSelection_signaltek") {
      this.setState({
        modal: true
      });
    }
    if (isCancel === "cancel" && modelType === "coppertestModal") {
      this.setState({
        copperTestCreate: false
      });
    }
    if (isCancel === "cancel" && modelType === "fibertestModal") {
      this.setState({
        fiberTestCreate: false
      });
    }
    if (isCancel != "cancel") {
      this.props.getUserPreference();
    }
  };

  edit = async () => {
    const { job } = this.props;
    if (!this.props.standards) {
      await this.props.getStandards();
    }
    if (!this.props.fiberStandards) {
      await this.props.getFiberStandards();
    }

    if (!this.props.custom) {
      this.props.getCustom();
    }
    if (job.deviceid) {
      if (
        this.state.selectedTests.length &&
        this.state.selectedTests[0].testtype === "39"
      ) {
        this.setState({
          fiberTestEdit: true
        });
        if (this.state.selectAll) {
          this.props.getFiberTest(this.state.tests.data[0].id);
        } else {
          this.props.getFiberTest(this.state.selectedTests[0].id);
        }
      } else {
        this.setState({
          editTestsModal: true
        });
      }
    } else {
      this.setState({
        editTestsModal: true
      });
    }
    if (this.state.selectAll) {
      this.props.getTest(this.state.tests.data[0].id);
    } else {
      this.props.getTest(this.state.selectedTests[0].id);
    }
  };

  recert() {
    if (!this.props.standards) {
      this.props.getStandards();
    }
    this.setState({
      recertTestModal: true
    });
  }
  onSaveRecertTest(test, pager) {
    let self = this;
    let selectedTests = [...self.state.selectedTests];
    if (selectedTests.length > 0) {
      test.testids = selectedTests.map(ele => ele.id);
    }
    this.props
      .saveRecertTest(test, pager)
      .then(resp => {
        this.setState({
          recertTestModal: false,
          selectedTests: [],
          selected: {},
          selectAll: false
        });
      })
      .catch(err => {
        this.setState({
          recertTestModal: true
        });
      });
  }
  closeRecert() {
    this.setState({
      recertTestModal: false
    });
  }
  onSaveEditTest(test, pager) {
    let self = this;
    let selectedTests = [...self.state.selectedTests];
    if (selectedTests.length > 0) {
      test.testids = selectedTests.map(ele => ele.id);
    }
    this.props
      .updateSignaltekTests(test, pager)
      .then(resp => {
        this.props.setSelectedTests(null);
        this.setState({
          selectedTests: [],
          selected: {},
          editTestsModal: false,
          editTestsModalError: null,
          fiberTestEdit: false
        });
      })
      .catch(err => {
        self.setState({
          editTestsModalError: err
        });
      });
  }

  closeEdit() {
    this.setState({
      editTestsModal: false,
      editTestsModalError: null,
      fiberTestEdit: false
    });
  }

  move() {
    this.setState({
      moveTestsModal: true
    });
  }
  onMoveTests(data) {
    const { pager } = this.props;
    const { selectAll, tests } = this.state;
    if (selectAll || data.testids.length === tests.data.length) {
      if (pager.pageIndex > 0) {
        pager.pageIndex -= 1;
      }
      if (pager.pageno > 1) {
        pager.pageno -= 1;
      }
    }
    this.props.moveTests(data, pager).then(response => {
      this.setState({
        selectedTests: [],
        selected: {},
        selectAll: false
      });
    });
    this.setState({
      moveTestsModal: null
    });
  }
  onMoveTestsClose() {
    this.setState({
      moveTestsModal: false
    });
  }
  showDeleteTestConfirm() {
    this.setState({
      deleteTestConfirm: true
    });
  }
  hideDeleteTestConfirm() {
    this.setState({
      deleteTestConfirm: false
    });
  }
  showDeleteTestChoice = () => {
    this.setState({
      deleteTestChoice: true
    });
  };
  hideDeleteTestChoice = () => {
    this.setState({
      deleteTestChoice: false
    });
  };
  showSubTestDeleteChoice = () => {
    this.setState({
      deleteSubTestChoice: true
    });
  };
  hideSubTestDeleteChoice = () => {
    this.setState({
      deleteSubTestChoice: false,
      subTests: {
        ping4: false,
        ping6: false,
        traceroute4: false,
        traceroute6: false,
        netscan: false,
        wiremap: false,
        poeload: false,
        maxthroughput: false,
        uptime: false,
        customdata: false,
        cabledata: false,
        webdata: false,
        voipdata: false,
        videodata: false,
        cctvdata: false
      }
    });
  };
  onDeleteTest() {
    const { pager, job } = this.props;
    const {
      selectedTests,
      selectAll,
      tests,
      deleteSubTestChoice,
      subTests
    } = this.state;
    let data;
    data = {
      testids: selectedTests.map((item, index) => item.id),
      jobid: job.id
    };

    if (selectAll || data.testids.length === tests.data.length) {
      pager.pageIndex = 0;
      pager.pageno = 1;
    }

    if (!deleteSubTestChoice) {
      this.props.deleteTests(data, pager).then(response => {
        this.setState({
          selectedTests: [],
          selected: {},
          selectAll: false
        });
      });
    } else {
      data = {
        ...data,
        ...subTests
      };
      this.props.deleteSubTests(data, pager).then(response => {
        this.setState({
          selectedTests: [],
          selected: {},
          selectAll: false
        });
      });
    }
    this.setState({
      deleteTestConfirm: false,
      deleteTestChoice: false,
      deleteSubTestChoice: false,
      subTests: {
        ping4: false,
        ping6: false,
        traceroute4: false,
        traceroute6: false,
        netscan: false,
        wiremap: false,
        poeload: false,
        maxthroughput: false,
        uptime: false,
        customdata: false,
        cabledata: false,
        webdata: false,
        voipdata: false,
        videodata: false,
        cctvdata: false
      }
    });
  }

  componentDidMount() {
    this.props.saveSelectedRow(null);
  }

  showReportGen() {
    const { selectedTests } = this.state;
    const { job } = this.props;
    const testids = selectedTests.map(test => test.id);
    this.state.nodeId = "";
    if (isSignalTEK10GType(job.deviceid)) {
      this.props.getCustomers({
        pageno: 0,
        pagesize: 0
      });
      this.setState({
        reportGenModal: true
      });
    } else {
      this.props
        .checkForReport({ testids, selectall: false, jobid: "" })
        .then(response => {
          if (response.testnames.length === 0) {
            this.props.getCustomers({
              pageno: 0,
              pagesize: 0
            });
            this.setState({
              reportGenModal: true
            });
          } else {
            let testNames = null;
            if (response.testnames.length > 10) {
              testNames = response.testnames.slice(0, 10).join(" ");
            } else {
              testNames = response.testnames.join(" ");
            }
            let resultCabletype = selectedTests.filter(
              x => x.result_cabletype !== null
            );
            if (resultCabletype.length !== selectedTests.length) {
              toast.info(` ${this.props.translate("report_generate_empty")}`, {
                position: toast.POSITION.TOP_CENTER,
                hideProgressBar: true
              });
            } else {
              toast.info(
                ` ${this.props.translate("report_generate_help")} ${testNames}`,
                {
                  position: toast.POSITION.TOP_CENTER,
                  hideProgressBar: true
                }
              );
            }
          }
        });
    }
  }

  showReportFromTreeview = (job) => {
    const { selectedTests } = this.state;
    const testids = selectedTests.map(test => test.id);

    this.setState({
      includeChildren: job.includeLowerRecords,
      nodeId: job.nodeId,
      treeviewJob: job,
      nodeTestCount: job.nodeTestCount
    });

      this.props
      .checkForReportForTreeview({ jobId: job.id, nodeId: job.nodeId, includeChildren: job.includeLowerRecords })
      .then(response => {
        this.setState({
          testCountForTreeview: job.nodeTestCount
        });
          if (response.testnames.length === 0) {
            this.props.getCustomers({
              pageno: 0,
              pagesize: 0
            });
            this.setState({
              reportGenModal: true
            });
          } else {
            let testNames = null;
            if (response.testnames.length > 10) {
              testNames = response.testnames.slice(0, 10).join(" ");
            } else {
              testNames = response.testnames.join(" ");
            }
            let resultCabletype = selectedTests.filter(
              x => x.result_cabletype !== null
            );
            if (resultCabletype.length !== selectedTests.length) {
              toast.info(` ${this.props.translate("report_generate_empty")}`, {
                position: toast.POSITION.TOP_CENTER,
                hideProgressBar: true
              });
            } else {
              toast.info(
                ` ${this.props.translate("report_generate_help")} ${testNames}`,
                {
                  position: toast.POSITION.TOP_CENTER,
                  hideProgressBar: true
                }
              );
            }
          }
        });
  }

  hideReportGen() {
    this.setState({
      reportGenModal: false
    });
  }

  generateReport = data => {
    const { job, lantekreportcount, cometreportcount } = this.props;
    const { selectedTests, nodeId, includeChildren, testCountForTreeview } = this.state;

    data.nodeId = nodeId;
    data.includeChildren = includeChildren;

    if (
      job &&
      job.deviceid &&
      job.deviceid.toLowerCase() === "comet_copper" &&
      data.type &&
      data.type.toLowerCase() !== "singleline" &&
      selectedTests.length > cometreportcount
    ) {
      toast.error(
        this.props.translate("brief_report_too_many_tests", {
          value: cometreportcount
        }),
        {
          position: toast.POSITION.TOP_CENTER,
          hideProgressBar: true
        }
      );
      return;
    }
    if (
      job &&
      !job.deviceid &&
      data.type &&
      data.type.toLowerCase() !== "singleline" &&
      selectedTests.length > lantekreportcount
    ) {
      toast.error(
        this.props.translate("brief_report_too_many_tests", {
          value: lantekreportcount
        }),
        {
          position: toast.POSITION.TOP_CENTER,
          hideProgressBar: true
        }
      );
      return;
    }
    this.props.generateReport(data);
    this.hideReportGen();
    this.setState({
      selectedTests: [],
      selected: {},
      selectAll: false
    });
  };

  componentWillReceiveProps(nextProps) {
    const { pager, job, profile, columnPresets } = nextProps;
    const defaultColumns = columnPresets.hasOwnProperty('SignalTEK10G')
      ? columnPresets['SignalTEK10G']
      : getPresetDefaultColumns('SignalTEK10G');

    if (this.props.pager.defaultColumns !== defaultColumns) {
      this.props.pager.defaultColumns = defaultColumns;
    }

    const { tests, test } = nextProps;
    if (nextProps.testsCreated) {
      this.setState({
        modal: false,
        copperTestCreate: false,
        fiberTestCreate: false
      });
    }
    if (pager.pageno !== this.props.pager.pageno) {
      this.setState({
        selectedTests: []
      });
    }
    if (tests) {
      this.setState({
        tests
      });
    }

    if (test !== this.state.test) {
      this.setState({
        test
      });
    }

    if (profile) {
      this.setState({
        lengthMeasurementUnit: profile.units
      });
    }

    this.setColumns(tests, defaultColumns, job, nextProps.preferences);
  }

  componentWillMount() {
    const { pager, setSelectedTests, job, selectColumnPreset, columnPresets } = this.props;
    const defaultColumns = columnPresets.hasOwnProperty('SignalTEK10G')
      ? columnPresets['SignalTEK10G']
      : getPresetDefaultColumns('SignalTEK10G');

    const { tests } = this.state;
    if (pager.filter && pager.filter.length > 0) {
      this.setState({ filterable: true });
    }
    if (job.deviceid && job.deviceid.includes("comet")) {
      this.setState({ jobType: "Lantek4" });
    } else if (job.deviceid && job.deviceid.includes("signaltek")) {
      this.setState({ jobType: "Signaltek" });
    }
    this.setColumns(tests, defaultColumns, job);
    setSelectedTests(null);

    selectColumnPreset(job && job.deviceid ? getSignalTEKPreset(job.deviceid) : "SignalTEK10G");
    this.props.resetJobTreeview(this.props);
  }

  setColumns(tests, defaultColumns, job, preferences) {
    const { translate, classes } = this.props;

    let {
      lengthMeasurementUnit,
      filterable,
      filterdate,
      selectedTime,
      selectedDate,
      createdatDateTime
    } = this.state;
    let columns = [];

    let _selectedTime, _selectedDate, _createdatDateTime;
    const isSignalTEKQTJob = job.deviceid && isSignalTEKQTType(job.deviceid);
    const isNaviTEKJob = job.deviceid && isNaviTEKType(job.deviceid);

    if (preferences && preferences.pager && preferences.pager.search) {
      let time = preferences.pager.search.find(
        x => x.field === "result_testtime"
      );
      if (time && time.searchvalue !== "") {
        _selectedTime = moment(time.searchvalue, ["HH:mm"]);
        _selectedTime = moment.utc(_selectedTime._i, _selectedTime._f).local();
      } else {
        _selectedTime = selectedTime;
      }

      let date = preferences.pager.search.find(
        x => x.field === "result_testdate"
      );
      if (date && date.searchvalue !== "") {
        let _date = moment(date.searchvalue, ["YYYY-MM-DD"]);
        _selectedDate = _date._d;
      } else {
        _selectedDate = selectedDate;
      }

      let createddatetime = preferences.pager.search.find(
        x => x.field === "result_createdat"
      );
      if (createddatetime && createddatetime.searchvalue !== "") {
        _createdatDateTime = moment(createddatetime.searchvalue, [
          "YYYY-MM-DD HH:mm"
        ]);
        _createdatDateTime = moment
          .utc(_createdatDateTime._i, _createdatDateTime._f)
          .local();
        _createdatDateTime = _createdatDateTime._d;
      } else {
        _createdatDateTime = createdatDateTime;
      }
    }
    if (tests) {
      let col = tests.columns.find(x => x.field !== "name");
      columns.push({
        id: "name",
        accessor: d => d.name,
        display: col ? col.display : true,
        show: true,
        filterable: filterable,
        Header: translate("tests_name"),
        minWidth: 200,
        Cell: o => {
          return (
            <React.Fragment>
              <TestsRowLink
                title={o.row.name}
                key={o.row.detail}
                link={`/results/${job.id}/${o.row.id}`}
              />
            </React.Fragment>
          );
        }
      });
      columns.push({
        id: "attachmentexists",
        display: false,
        show: true,
        filterable: false,
        Header: "",
        width: 25,
        resizable: false,
        Cell: o => {
          return (
            <React.Fragment>
              {o.original.attachmentexists && (
                <Button
                  mini
                  onClick={e => this.showAttachments(e, job.id, o.original.id)}
                  id={job.id}
                  className={classes.attachment}
                >
                  <Icon>attach_file</Icon>
                </Button>
              )}
            </React.Fragment>
          );
        }
      });
      col = tests.columns.find(x => x.field !== "result_teststatus");
      columns.push({
        id: "result_teststatus",
        accessor: d => d.result_teststatus,
        display: col ? col.display : true,
        filterable: false,
        show: true,
        Header: "", //translate('result_teststatus'),
        width: 25,
        resizable: false,
        Cell: o => {
          if (
            o.row.result_teststatus &&
            o.row.result_teststatus.toLowerCase() === "passed"
          ) {
            return (
              <React.Fragment>
                <div style={{ marginTop: 5 }}>
                  <Icon className={classes.passState}>check_circle</Icon>
                </div>
              </React.Fragment>
            );
          } else if (
            o.row.result_teststatus &&
            o.row.result_teststatus.toLowerCase() === "failed"
          ) {
            return (
              <React.Fragment>
                <div style={{ marginTop: 5 }}>
                  <Icon className={classes.failState}>cancel</Icon>
                </div>
              </React.Fragment>
            );
          } else if (
            o.row.result_teststatus &&
            o.row.result_teststatus.toLowerCase() === "aborted"
          ) {
            return (
              <React.Fragment>
                <div style={{ marginTop: 5 }}>
                  <Icon className={classes.failState}>cancel</Icon>
                </div>
              </React.Fragment>
            );
          } else {
            return null;
          }
        }
      });
      col = tests.columns.find(x => x.field !== "result_testdate");
      columns.push({
        id: "result_testdate",
        accessor: d => d.result_testdate,
        display: col ? col.display : true,
        show: true,
        filterable: filterable,
        Header: translate("result_testdate") + "/" + translate("result_testtime"),
        Cell: o => {
          return o.row.result_testdate
            ? dateTimeFormatter(o.row.result_testdate)
            : "";
        },
        width: 175,
        Filter: ({ filter, onChange }) => {
          return (
            <React.Fragment>
              <MuiPickersUtilsProvider utils={MomentUtils} moment={moment}>
                <div className="picker">
                  <DatePicker
                    value={_selectedDate || null}
                    onChange={event => {
                      this.setState(
                        {
                          selectedDate: event ? event._d : null
                        },
                        () => {
                          if (!event) {
                            onChange("");
                            return "";
                          }
                          let date = getISODateString(event._d);
                          onChange(date);
                          return date;
                        }
                      );
                    }}
                    disableFuture={true}
                    clearable
                    format="DD/MM/YYYY"
                  />
                </div>
              </MuiPickersUtilsProvider>
            </React.Fragment>
          );
        }
      });
      col = tests.columns.find(x => x.field !== "result_testtime");
      columns.push({
        id: "result_testtime",
        accessor: d => d.result_testtime,
        display: col ? col.display : true,
        show: true,
        filterable: false,
        Header: translate("result_testtime"),
        Cell: o => {
          let time = "";
          if (o.row.result_testtime) {
            const _date = moment(o.row.result_testtime, ["HH:mm"]);
            time = _date ? timeFormatter(_date) : "";
          }
          return time ? time : o.row.result_testtime;
        },
        Filter: ({ filter, onChange }) => {
          return (
            <React.Fragment>
              <MuiPickersUtilsProvider utils={MomentUtils} moment={moment}>
                <div className="picker">
                  <TimePicker
                    clearable
                    ampm={false}
                    // keyboard
                    value={_selectedTime}
                    onChange={event => {
                      this.setState(
                        {
                          selectedTime: event ? event._d : null
                        },
                        () => {
                          if (!event) {
                            onChange("");
                            return "";
                          }
                          let time = getISOTimeString(event._d);
                          onChange(time);
                        }
                      );
                    }}
                  />
                </div>
              </MuiPickersUtilsProvider>
            </React.Fragment>
          );
        }
      });

      col = tests.columns.find(x => x.field !== "result_createdat");
      columns.push({
        id: "result_createdat",
        accessor: d => d.result_createdat,
        display: col ? col.display : true,
        show: false,
        filterable: filterable,
        Header: translate("result_createdat"),
        Cell: o => {
          let time = "";
          if (o.row.result_createdat) {
            time = moment(o.row.result_createdat, ["YYYY-MM-DD HH:mm"]);
            time = dateTimeFormatter(time.toString());
          }

          return o.row.result_createdat ? time : "";
        },
        Filter: ({ filter, onChange }) => {
          return (
            <React.Fragment>
              <MuiPickersUtilsProvider utils={MomentUtils} moment={moment}>
                <div className="picker">
                  <DatePicker
                    disableFuture={true}
                    clearable
                    ampm={false}
                    format="DD/MM/YYYY"
                    value={_createdatDateTime || null}
                    onChange={event => {
                      this.setState(
                        {
                          createdatDateTime: event ? event._d : null
                        },
                        () => {
                          if (!event) {
                            onChange("");
                            return "";
                          }
                          let time = getISODateString(event._d);
                          onChange(time);
                        }
                      );
                    }}
                  />
                </div>
              </MuiPickersUtilsProvider>
            </React.Fragment>
          );
        }
      });

      let _tests = tests.columns
        ? tests.columns.filter(x => x.field !== "name")
        : [];
      _tests = _tests.filter(x => x.field != "rowMove");
      _tests = _tests.filter(x => x.field !== "result_teststatus");
      _tests = _tests.filter(x => x.field !== "result_testdate");
      _tests = _tests.filter(x => x.field !== "result_testtime");
      _tests = _tests.filter(x => x.field !== "result_suspicious");
      _tests = _tests.filter(x => x.field !== "result_createdat");
      let keys = [1, 2, 3, 4, 5, 6];
      keys.map(k => {
        _tests = _tests.filter(x => x.field !== `level${k}value`);
        _tests = _tests.filter(x => x.field !== `level${k}key`);
        return k;
      });
      _tests = _tests.filter(x => x.field !== "result_suspicious");

      _tests = _tests.sort((x, y) => {
        if (x.order < y.order) return -1;
        if (x.order > y.order) return 1;
        return 0;
      });

     _tests = _tests.filter(x => !x.field.startsWith("mobiletest_"));

     let _serialNumberTests = _tests.filter(x => x.field == "result_neserialnumber");
      let serialNumberCol = (_serialNumberTests && (_serialNumberTests.length > 0)) ? _serialNumberTests[0] : null;
      _tests = _tests.filter(x => x.field !== "result_neserialnumber");

      _tests.forEach((column, index) => {
        if (
          [
            "result_network",
            "result_transmission",
            "result_wiremap",
            "result_poeload",
            "result_fiber"
          ].includes(column.field)
        ) {
          columns.push({
            id: column.field,
            Header: translate(column.field),
            accessor: d => d[column.field],
            show: defaultColumns.includes(column.field),
            display: column.display,
            group: column.group,
            filterable: column.cansearch && filterable,
            Filter: ({ filter, onChange }) => {
              let value = filter ? filter.value : "";
              return (
                <React.Fragment>
                  <TextField
                    value={value}
                    onChange={e => {
                      let val = e.target.value;
                      onChange(val);
                    }}
                  />
                </React.Fragment>
              );
            },
            Cell: o => {
              if (
                o.row[column.field] &&
                o.row[column.field].toLowerCase() === "passed"
              ) {
                return (
                  <React.Fragment>
                    <div style={{ marginTop: 5 }}>
                      <Icon className={classes.passState}>check_circle</Icon>
                    </div>
                  </React.Fragment>
                );
              } else if (
                o.row[column.field] &&
                o.row[column.field].toLowerCase() === "failed"
              ) {
                return (
                  <React.Fragment>
                    <div style={{ marginTop: 5 }}>
                      <Icon className={classes.failState}>cancel</Icon>
                    </div>
                  </React.Fragment>
                );
              }
            }
          });
        } else {
          columns.push({
            id: column.field,
            Header: translate(column.field),
            accessor: d => d[column.field],
            show: defaultColumns.includes(column.field),
            display: column.display,
            group: column.group,
            filterable: column.cansearch && filterable
          });
          if ((column.field == "result_tester") && (serialNumberCol != null)) {
            columns.push({
              id: serialNumberCol.field,
              Header: translate(serialNumberCol.field),
              accessor: d => d[serialNumberCol.field],
              show: defaultColumns.includes(serialNumberCol.field),
              display: serialNumberCol.display,
              group: serialNumberCol.group,
              filterable: serialNumberCol.cansearch && filterable
            });
          }
        }
      });

      col = tests.columns.find(x => x.field === "result_suspicious");
      columns.push({
        id: "result_suspicious",
        accessor: d => d.result_suspicious,
        display: col ? col.display : true,
        filterable: filterable,
        show: false,
        Header: translate("result_suspicious"),
        Cell: o => {
          if (o.row.result_suspicious) {
            return (
              <React.Fragment>
                <Icon>flag</Icon>
              </React.Fragment>
            );
          }
        }
      });
    }

    let aggregateCols = columns.filter(x => x.group).map(x => x["id"]);
    aggregateCols = [
      "level2value",
      "level3value",
      "level4value",
      "level5value",
      "level6value",
      "level2key",
      "level3key",
      "level4key",
      "level5key",
      "level6key"
    ];

    let lengthCol = columns.find(x => x.id === "result_length");
    let lengthColIdx = columns.findIndex(x => x.id === "result_length");
    lengthCol = {
      ...lengthCol,
      Header:
        lengthMeasurementUnit === "feet"
          ? translate("result_length_f")
          : translate("result_length_m"),
      Filter: ({ filter, onChange }) => {
        let value = filter ? filter.value : "";
        return (
          <React.Fragment>
            <TextField
              value={value}
              onChange={e => {
                let val = e.target.value;
                onChange(val);
              }}
            />
          </React.Fragment>
        );
      },
      Cell: o => {
        let val = "";
        if (o) {
          val = o.value;
          if (lengthMeasurementUnit === "feet") {
            return metersToFeet(val);
          }
        }
        return getFormattedNumber(val);
      }
    };

    if (preferences && preferences.columns) {
      preferences.columns.map(x => {
        columns.find(y => {
          if (x.id === y.id) {
            y.show = x.show;
            return true;
          }
          return false;
        });
        return x;
      });
    }
    columns[lengthColIdx] = lengthCol;

    if (isSignalTEKQTJob) {
      let wiremapCol = columns.find(x => x.id === "result_wiremap");
      let wiremapColIdx = columns.findIndex(x => x.id === "result_wiremap");
      wiremapCol = {
        ...wiremapCol,
        Header: translate("qualification")
      }
      columns[wiremapColIdx] = wiremapCol;
    }

    if (isSignalTEKQTJob || isNaviTEKJob) {
      columns = columns.filter(x => x.id !== "result_transmission");
      let fllCol = columns.find(x => x.id === "result_fiber");
      let fllColIdx = columns.findIndex(x => x.id === "result_fiber");
      fllCol = {
        ...fllCol,
        Header: translate("fiberqualification")
      }
      columns[fllColIdx] = fllCol;
    }

    if (preferences && preferences.columns) {
      preferences.columns.map(x => {
        columns.find(y => {
          if (x.id === y.id) {
            y.show = x.show;
            return true;
          }
          return false;
        });
        return x;
      });
    }
    
    let newColumns = columns.filter(x => x.id !== "result_standard" && x.id !== "result_cablename" && x.id !== "result_testtime");
    this.setState({
      columns: newColumns,
      aggregateCols
    });
  }

  selectedRows = (rows, prevTests) => {
    let { selectedTests } = this.state;
    const { tests, pager } = this.props;
    if (prevTests.length > 0) {
      selectedTests = prevTests;
    } else {
      selectedTests = [];
    }

    Object.keys(rows).map(key => {
      if (rows[key]) {
        selectedTests.push(tests.data.find(x => x.id === parseInt(key, 10)));
      } else {
        selectedTests.forEach((element, idx) => {
          if (element && element.id.toString() === key) {
            selectedTests.splice(idx, 1);
          }
        });
      }
      return key;
    });
    selectedTests = selectedTests.filter(i => i !== undefined);
    selectedTests = this.getUnique(selectedTests, "id");
    this.sortSelection(pager.order, selectedTests);
    this.setState({
      selectedTests,
      selectAll:
        tests.data.length === tests.data.filter(e => rows[e.id]).length,
      selected: rows,
      testSelected: rows
    });
  };

  getUnique = (arr, comp) => {
    const unique = arr
      .map(e => e[comp])
      .map((e, i, final) => final.indexOf(e) === i && i)
      .filter(e => arr[e])
      .map(e => arr[e]);

    return unique;
  };

  onSortedChange(newSorted, column, shiftKey) {
    let { selectedTests } = this.state;
    this.sortSelection(
      {
        field: newSorted.field,
        sorttype: newSorted.desc ? "desc" : "asc"
      },
      selectedTests
    );
  }

  sortSelection(sort, selectedTests) {
    const { setSelectedTests } = this.props;

    if (Object.keys(sort).length) {
      selectedTests = selectedTests.sort((x, y) => {
        return x[sort.field] !== y[sort.field]
          ? x[sort.field] < y[sort.field]
            ? -1
            : 1
          : 0;
      });
      if (sort.sorttype === "desc") {
        selectedTests = selectedTests.reverse();
      }
    } else {
      selectedTests = selectedTests.sort((x, y) => {
        return x.name !== y.name ? (x.name < y.name ? -1 : 1) : 0;
      });
    }
    setSelectedTests(selectedTests.length ? selectedTests : null);
  }

  toggle() {
    this.setState({
      contextMenu: !this.state.contextMenu
    });
  }

  toggleFilters = () => {
    if (this.state.filterable) {
      {
        /* this.props.resetSearchFilter() */
      }
    }
    this.setState(
      {
        filterable: !this.state.filterable
      },
      () => {
        const { pager, job } = this.props;
        const { defaultColumns } = pager;
        const { tests } = this.state;
        this.setColumns(tests, defaultColumns, job);
      }
    );
  };

  applyPreset(presetColumns) {
    const { selectColumnPreset } = this.props;

    selectColumnPreset(presetColumns);
  }

  toggleColumns(column) {
    const {
      savePreferences,
      pager,
      preferencesSaved,
      preferences
    } = this.props;
    let columns =
      preferences && preferences.columns
        ? [...preferences.columns]
        : [...this.state.columns];
    pager.defaultColumns = [];
    columns.forEach(c => {
      if (c.id === column.id) {
        c.show = column.show;
      }
      if (c.show) {
        pager.defaultColumns.push(c.id);
      }
    });
    this.setState({
      columns: columns
    });

    if (savePreferences && preferencesSaved) {
      savePreferences(pager, columns, preferencesSaved, true);
    }
  }
}

const mapStateToProps = (state) => ({
  nodeSelectedIds: state.treeviewReducer.nodeSelectedIds,
  modifiedJobId: state.jobReducer.modifiedJobId,
  fileUploadSettings: state.appSettingReducer.fileUploadSettings,
  ...state
});

const mapDispatchToProps = (dispatch, props) => ({
  resetJobTreeview: (props) => {
    dispatch(resetJobTreeview());
  }
});

export default
connect(mapStateToProps, mapDispatchToProps)
(withRouter(withStyles(styles)(SignalTek10GJob)));



// WEBPACK FOOTER //
// ./src/components/job/signaltek10g/index.js